import { render, staticRenderFns } from "./templateHeight.vue?vue&type=template&id=aa4ea486&scoped=true"
import script from "./templateHeight.vue?vue&type=script&lang=js"
export * from "./templateHeight.vue?vue&type=script&lang=js"
import style0 from "./templateHeight.vue?vue&type=style&index=0&id=aa4ea486&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa4ea486",
  null
  
)

export default component.exports